// Data Program Studi STIKES Baramuli
const programStudi = [
  {
    id: 1,
    kode: "S1-KEP",
    nama: "S1 Keperawatan",
    jenjang: "Sarjana (S1)",
    akreditasi: "B",
    deskripsi: "Program studi yang mempersiapkan lulusan menjadi perawat profesional yang kompeten dalam memberikan asuhan keperawatan komprehensif.",
    iconType: "hospital",
    durasi: "4 Tahun",
    gelar: "S.Kep"
  },
  {
    id: 2,
    kode: "NERS",
    nama: "Profesi Ners",
    jenjang: "Profesi",
    akreditasi: "B",
    deskripsi: "Program profesi yang melanjutkan kompetensi keperawatan untuk menjadi Ners yang siap praktik di berbagai setting pelayanan kesehatan.",
    iconType: "userNurse",
    durasi: "1 Tahun",
    gelar: "Ns"
  },
  {
    id: 3,
    kode: "S1-KM",
    nama: "S1 Kesehatan Masyarakat",
    jenjang: "Sarjana (S1)",
    akreditasi: "B",
    deskripsi: "Program studi yang fokus pada upaya promotif dan preventif kesehatan masyarakat.",
    iconType: "globe",
    durasi: "4 Tahun",
    gelar: "S.KM"
  }
];

export default programStudi;
